(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dicom-parser"));
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneDICOMImageLoader", ["dicom-parser"], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneDICOMImageLoader"] = factory(require("dicom-parser"));
	else
		root["cornerstoneDICOMImageLoader"] = factory(root["dicomParser"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__713__) => {
return 